import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/zeit/45b021a8/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const ComponentDemo = makeShortcode("ComponentDemo");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <ComponentDemo links={{
      React: 'http://react.carbondesignsystem.com/?path=/story/buttons--default',
      Angular: 'https://angular.carbondesignsystem.com/?path=/story/components-button--basic',
      Vue: 'http://vue.carbondesignsystem.com/?path=/story/components-cvbutton--default',
      Vanilla: 'https://the-carbon-components.netlify.com/?nav=button'
    }} knobs={{
      Button: ['kind', 'disabled', 'size']
    }} mdxType="ComponentDemo">{`<Button>Hello World!</Button>`}</ComponentDemo>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      